export default __webpack_public_path__ + "static/media/4.e754d9c2.jpg";